import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CartControlFormGroup } from '../../cart-control-form.component';

@Component({
  selector: 'cart-control-form-settings',
  templateUrl: './cart-control-form-settings.component.html',
  styleUrl: './cart-control-form-settings.component.scss',
  standalone: false,
})
export class CartControlFormSettingsComponent {
  @Input() formGroup: FormGroup<CartControlFormGroup>;
}
